import { strings } from 'res';
import { DashboardIcon, OrderIcon, ReportIcon, DeliveryIcon } from "../assets/svg/icon";
import { UserOutlined, DatabaseOutlined, WarningOutlined, SettingOutlined, CheckCircleOutlined, CameraOutlined, FileOutlined, BuildOutlined, DownCircleOutlined, BookOutlined } from '@ant-design/icons';

import { all_privileges, admin_privileges, ba, admin_pmo, pmo_ba, verifikator, finished_projects, sertifikator, pmo, admin_ba } from "res/privileges/index";

const dashBoardNavTree = [{
  key: "Home",
  path: strings.navigation.path.dashboard,
  title: "Home",
  breadcrumb: false,
  submenu: [
    {
      key: "Dashboard",
      path: strings.navigation.path.dashboard,
      title: "Dashboard",
      icon: DashboardIcon,
      breadcrumb: false,
      access: all_privileges,
      submenu: []
    },
    {
      key: "Monitoring BA",
      path: strings.navigation.path.my_ba,
      title: "Monitoring BA",
      icon: UserOutlined,
      breadcrumb: false,
      access: admin_pmo,
      submenu: []
    },
    {
      key: "Dalam Pengawasan",
      path: strings.navigation.path.kdkmp_dalam_pengawasan,
      title: "Dalam Pengawasan",
      icon: CameraOutlined,
      breadcrumb: false,
      access: pmo_ba,
      submenu: []
    },
    {
      key: "Laporan BA",
      path: strings.navigation.path.laporan_ba,
      title: "Laporan BA",
      icon: ReportIcon,
      breadcrumb: false,
      access: admin_ba,
      submenu: []
    },
    {
      key: "Laporan PMO",
      path: strings.navigation.path.laporan_pmo,
      title: "Laporan PMO",
      icon: BookOutlined,
      breadcrumb: false,
      access: admin_pmo,
      submenu: []
    },
    {
      key: "Atur KDKMP",
      path: strings.navigation.path.my_projects,
      title: "Atur KDKMP",
      icon: FileOutlined,
      breadcrumb: false,
      access: pmo,
      submenu: []
    },
    {
      key: "Atur KDKMP",
      path: strings.navigation.path.my_projects_ba,
      title: "Atur KDKMP",
      icon: FileOutlined,
      breadcrumb: false,
      access: ba,
      submenu: []
    },
    {
      key: "Semua KDKMP",
      path: strings.navigation.path.projects,
      title: "Semua KDKMP",
      icon: BuildOutlined,
      breadcrumb: false,
      access: admin_privileges,
      submenu: []
    },
    // {
    //   key: "Proses Pengajuan",
    //   path: strings.navigation.path.open_projects,
    //   title: "Proses Pengajuan",
    //   icon: DeliveryIcon,
    //   breadcrumb: false,
    //   access: admin_pmo,
    //   submenu: []
    // },
    {
      key: "KDKMP Beroperasi",
      path: strings.navigation.path.finished_projects,
      title: "KDKMP Beroperasi",
      icon: CheckCircleOutlined,
      breadcrumb: false,
      access: admin_pmo,
      submenu: []
    },
    // {
    //   key: "Verifikasi KDKMP",
    //   path: strings.navigation.path.verification_projects,
    //   title: "Verifikasi KDKMP",
    //   icon: DatabaseOutlined,
    //   breadcrumb: false,
    //   access: admin_privileges,
    //   submenu: []
    // },
    {
      key: "KDKMP Bermasalah",
      path: strings.navigation.path.bermasalah,
      title: "KDKMP Bermasalah",
      icon: WarningOutlined,
      breadcrumb: false,
      access: admin_pmo,
      submenu: []
    },
    {
      key: "Pengguna",
      path: strings.navigation.path.users,
      title: "Pengguna",
      icon: UserOutlined,
      access: admin_privileges,
      breadcrumb: false,
      submenu: []
    },
  ]
}]

const ControlTree = [{
  key: "Pengaturan",
  path: strings.navigation.path.settings,
  title: "Pengaturan",
  breadcrumb: false,
  submenu: [
    {
      key: "Pengaturan",
      path: strings.navigation.path.settings,
      title: "Pengaturan",
      icon: SettingOutlined,
      breadcrumb: false,
      access: all_privileges,
      submenu: []
    }
  ]
}]

const navigationConfig = [
  ...dashBoardNavTree,
  ...ControlTree,
]

export default navigationConfig;